import React, { Fragment } from 'react'
import { Link, useLocation } from 'react-router-dom'
import './Slide.scss'

const Slide = ({ slug, filename, filepath, className }) => {
  const { pathname } = useLocation()
  const linkbase = pathname === '/' ? pathname : `${pathname}/`;
  const InnerSlide = slug ? Link : Fragment
  const InnerSlideProps = slug ? { to: `${linkbase}${slug}` } : {}

  return (
    <div
      className={ ['slide', ...(className.split(' '))].join(' ') }
    >
      <InnerSlide { ...InnerSlideProps }>
        <span
          className="slide--image"
          style={{ backgroundImage:`url(${filepath}${filename})` }}
        />
      </InnerSlide>
    </div>
  )
}

export default Slide;